import { useMutation, gql } from '@apollo/client';
import { translate } from 'javascripts/translations/i18n';
import toast from 'helpers/toast';
import Schema from 'javascripts/graphql/Schema';
import Steven from 'helpers/steven';
import { graphQLIdDecoder } from 'helpers/graphql-utils';

const EDIT_PROJECT_TASK = gql`
  mutation EditProjectTask($input: ProjectTaskUpdateDetailsInput!) {
    projectTaskUpdateDetails(input: $input) {
      errors {
        error
        message
      }
      projectTask {
        id
        details
      }
    }
  }
`;
const useEditProjectTask = ({ taskId, source }) => {
  const [editProjectTaskMutation] = useMutation(EDIT_PROJECT_TASK, {
    onCompleted: (response) => {
      const errors = response.projectTaskUpdateDetails?.errors;
      if (errors?.length) {
        toast.error(errors[0].message);
        return;
      }

      const projectTaskId = response.projectTaskUpdateDetails?.projectTask?.id;
      const projectTaskDbId = graphQLIdDecoder(projectTaskId)?.databaseId;

      if (projectTaskDbId) {
        Steven.entityCrud({
          entity_id: projectTaskDbId,
          entity_type: 'project_task',
          action: 'updated',
          source,
        });
      }
    },
    onError: () => {
      toast.error(translate('projectTasks.editTaskErrorMsg'));
    },
    update: (cache, { data }) => {
      if (data?.projectTaskUpdateDetails?.errors?.length) {
        return;
      }

      const updatedProjectTask = data?.projectTaskUpdateDetails?.projectTask;
      if (updatedProjectTask?.id) {
        cache.modify({
          id: cache.identify({
            __typename: Schema.Types.ProjectTask,
            id: taskId,
          }),
          fields: {
            details() {
              cache.writeFragment({
                data: updatedProjectTask,
                fragment: gql`
                  fragment UpdatedProjectTask on ProjectTask {
                    id
                    details
                  }
                `,
              });
              return updatedProjectTask.details;
            },
          },
        });
      }
    },
  });

  const editProjectTask = async ({ details }) => {
    await editProjectTaskMutation({
      variables: {
        input: {
          id: taskId,
          details,
        },
      },
    });
  };

  return {
    editProjectTask,
  };
};

export default useEditProjectTask;
